import { formatSrcSet } from '../../../utils/formatURLs';
import { TechnologyPageWrapper } from './styles';

export type TechnologyPageTemplateProps = {
  language?: string;
  title: string;
  html: string;
  image: string;
  slug?: string;
};

const TechnologyPageTemplate: React.FC<TechnologyPageTemplateProps> = ({ title, html, image }) => {
  return (
    <TechnologyPageWrapper>
      <div>
        <div>
          <h1 style={{ margin: 0, padding: 0, lineHeight: '70px' }}>{title}</h1>
          {image && <img srcSet={formatSrcSet(image, 'technology')} alt={title} />}
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </TechnologyPageWrapper>
  );
};

export default TechnologyPageTemplate;
